import { Validator } from 'vee-validate'
import abfrlbookinglogs from './abfrlbookinglogs/index.vue';
import abfrlprocesslogs from './abfrlprocesslogs/index.vue';
import abfrlwarehouse from './abfrlwarehouse/index.vue';
import abfrlcustomerdata from './abfrlcustomerdetails/index.vue';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';

export default {
 components: {
   'first' : abfrlcustomerdata,
   'second' : abfrlwarehouse,
   'third': abfrlbookinglogs,
   'fourth': abfrlprocesslogs,
 },
 data() {
   return {
     currentTab: 'First',
     componentKey:1,
     tabs: [
       { key:'First', value:' Customer Details'},
       { key:'Second', value:' Warehouse Details'},
       { key:'Third', value:' Booking Logs' },
       { key:'Fourth', value:'Files Process Logs' },
     ],
     useremail : '',
     isLoading: false,
     useremail : '',
     clientsystemid : '',
     companyshortname : ''
   }
 },
 created:function() {
 },
 computed: {
   // selects all checkbox's option
   currentTabComponent: function () {
     this.componentKey += 1;
     return this.currentTab.toLowerCase()
   }
 },
 mounted() {
   //console.log("bookingData",this.bookingData);
 },
 methods: {

 }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/abfrlLogs/abfrlLogs.component.js